export default __webpack_public_path__ + "static/media/thermal.86d90e8c.png";